<script lang="ts">
  import { getUserId } from '~/auth/utils';
  import { prettyDate } from '~/utils/dates';
  import { getUserQuery } from './mutations.svelte';

  const user = getUserQuery();
</script>

<table class="device-table">
  <thead>
    <tr>
      <td><b>Device ID</b></td>
      <td align="right"><b>Last Signed In</b></td>
    </tr>
  </thead>
  <tbody>
    {#if user.data?.user_device_map}
      {#each user.data.user_device_map as device}
        <tr class:active={device.device_id === getUserId()}>
          <td class="device-id">
            {device.device_id.split('-')[0]}
          </td>
          <td align="right">
            {prettyDate(device.created_at)}
          </td>
        </tr>
      {/each}
    {/if}
  </tbody>
</table>

<style lang="scss">
  @use '~/theme/themify' as *;
  table {
    width: 100%;
  }
  .device-id {
    font-family: monospace;
  }
  .active {
    @include themify {
      color: themed('star-bonus');
    }
  }
</style>
